import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

let element = document.getElementById('dl-calc')
ReactDOM.render(
  <React.StrictMode>
    <App myPropsObject={element.dataset} />
  </React.StrictMode>,
    element
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
